import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { toast } from 'sonner';
import { Plane } from 'lucide-react';

import { API } from '../config';

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const params = new URLSearchParams(hash.replace('#', '?'));
    const sessionId = params.get('session_id');

    if (!sessionId) {
      navigate('/');
      return;
    }

    axios.post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then(res => {
        setUser(res.data.user);
        if (res.data.token) {
          localStorage.setItem('fly_token', res.data.token);
        }
        toast.success('Welcome to Fly N Out! ✈️');
        navigate('/dashboard');
      })
      .catch(() => {
        toast.error('Authentication failed');
        navigate('/');
      });
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <Plane className="w-12 h-12 text-[#FF4500] mx-auto mb-4 animate-bounce" />
        <p className="text-lg font-medium" style={{ fontFamily: 'Space Grotesk' }}>Boarding you in...</p>
        <p className="text-sm text-muted-foreground mt-1">Verifying your credentials</p>
      </div>
    </div>
  );
}
